import React, { useRef } from "react";
import emailjs from "@emailjs/browser"; // Updated import
import "./styles/Contact.scss";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_3jrfo45", // Replace with your EmailJS Service ID
        "template_6dc1fsk", // Replace with your EmailJS Template ID
        form.current,
        "iObXKQfdcD3kow2Xf" // Replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Message sent successfully!");
          form.current.reset(); // Reset the form after submission
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <section className="contact-section">
      <div className="contact-container">
        <div className="form-container">
          <h1>Contact Us</h1>
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-group">
              <input
                type="text"
                id="name"
                name="name"
                required
                onFocus={(e) => e.target.classList.add("has-value")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.classList.remove("has-value");
                }}
              />
              <label htmlFor="name">*Name</label>
            </div>
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                required
                onFocus={(e) => e.target.classList.add("has-value")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.classList.remove("has-value");
                }}
              />
              <label htmlFor="email">*Email</label>
            </div>
            <div className="form-group">
              <input
                type="text"
                id="subject"
                name="subject"
                required
                onFocus={(e) => e.target.classList.add("has-value")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.classList.remove("has-value");
                }}
              />
              <label htmlFor="subject">*Subject</label>
            </div>
            <div className="form-group">
              <textarea
                id="message"
                name="message"
                required
                onFocus={(e) => e.target.classList.add("has-value")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.classList.remove("has-value");
                }}
              ></textarea>
              <label htmlFor="message">*Message</label>
            </div>
            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
